/**
 * Popup
 *
 * This component requires jQuery.
 * You can require it on the page using <div data-component="popup"></div>
 */
import 'magnific-popup';
$(function () {
  $('[data-component="popup"]').each(function () {
    let $holder = $(this);
    $holder.magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  });
});